var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldTicketExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3 14.4c.38 0 .7.31.7.69 0 3.84-1.16 5-5 5h-5.25V18.5c0-.39-.3-.71-.68-.74a.17.17 0 0 0-.07-.01c-.41 0-.75.34-.75.75v1.59H8.49c-1.88 0-2.85-1.41-3.73-3.54l-.17-.42a.7.7 0 0 1 .39-.91c.37-.14.66-.43.81-.81.16-.37.16-.78.01-1.15-.32-.77-1.2-1.14-1.98-.83-.17.08-.37.08-.54 0a.726.726 0 0 1-.38-.39l-.15-.4c-1.49-3.62-.84-5.17 2.78-6.67l2.45-1.01c.36-.15.77.02.91.38l2.18 4.75c-.41 0-.82.33-.82.74v4.34c0 .41.34.75.75.75.02 0 .05 0 .07-.01.38-.03.68-.35.68-.74V9.83c0-.39-.3-.71-.68-.74V4.93H17c3.84 0 5 1.16 5 5v.85c0 .39-.32.7-.7.7-.8 0-1.45.65-1.45 1.46 0 .8.65 1.46 1.45 1.46z",
    fill: "{props.color}",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldTicketExpired);
export default __webpack_public_path__ + "static/media/vuesax-bold-ticket-expired.a43fbeedeb038401ab293763c53c334b.svg";
export { ForwardRef as ReactComponent };